import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalContentComponent {}
